import { omit } from 'lodash';

import { NotableMarkdown, isDefined } from 'common';

import { FieldReferenceCodeMirror } from '../../../../Runs/Run/Drawer/ContentTabs/FieldReference/CodeMirror';
import { type ProducedType } from '../../../types';
import { type OutputContentProps } from '../../types';

export function DefaultReturnValueContent(props: OutputContentProps<typeof ProducedType.Any>) {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    returnValue,
    isFullHeightView,
  } = props;

  if (!isDefined(returnValue)) {
    // this default returnValue component does nothing without a returnValue, but Custom returnValue components may
    return null;
  }

  if (typeof returnValue === 'string') {
    return <NotableMarkdown>{returnValue}</NotableMarkdown>;
  }

  if (typeof returnValue === 'object' && 'markdown' in returnValue) {
    // If block return value includes magic 'markdown' key, render it as markdown in addition to other keys
    return (
      <>
        <NotableMarkdown>
          {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            returnValue.markdown
          }
        </NotableMarkdown>
        ;
        <FieldReferenceCodeMirror
          content={JSON.stringify(omit(returnValue, 'markdown'), null, 2)}
          isFullHeightView={isFullHeightView}
        />
      </>
    );
  }

  return (
    <FieldReferenceCodeMirror
      content={JSON.stringify(returnValue, null, 2)}
      isFullHeightView={isFullHeightView}
    />
  );
}
